module.exports = __webpack_public_path__ + "img/jinchunhua.ab93c22a.jpg";